
import anime from 'animejs';
import {AnimeParams, AnimeInstance} from 'animejs'
import {defineComponent, ref} from '@nuxtjs/composition-api';
export default defineComponent({
    
    setup(props){
        
        const loading = ref(false)
        const el = ref<HTMLElement>(null)
        const start = () => {
            loading.value = true;
            
        }
        const finish = () => {

                // this.anim?.pause()
                
                anime({
                    targets: el.value,
                    opacity: [1, 0],
                    easing: 'easeInOutQuad',
                    duration: 200,
                    delay: 300,
                    complete: () => {
                        loading.value = false;
                    }
                })
            
            
            
        }  
        return {
            loading,
            finish,
            start,
            el
        }
    },
    

})
